import React from "react";
const StreakCalendar = ({ streak, isPremium, streakHistory = [] }) => {
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();

  // Get days in current month
  const firstDay = new Date(currentYear, currentMonth, 1);
  const lastDay = new Date(currentYear, currentMonth + 1, 0);
  const daysInMonth = lastDay.getDate();
  const startingDayOfWeek = firstDay.getDay();

  // Mark streak days
  const streakDays = new Set();
  for (let i = 0; i < streak; i++) {
    const day = today.getDate() - i;
    if (day <= 0) break; // streak goes into previous month — stop marking
    streakDays.add(day);
  }

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        borderRadius: "16px",
        padding: "1.5rem",
        color: "#fff",
        maxWidth: "400px",
        margin: "2rem auto",
      }}
    >
      {/* Premium Badge */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem",
          marginBottom: "1rem",
          fontSize: "0.875rem",
          fontWeight: "600",
          background: "rgba(255,255,255,0.2)",
          padding: "0.5rem 1rem",
          borderRadius: "8px",
        }}
      >
        👑 PREMIUM FEATURE
      </div>

      {/* Month Title */}
      <div
        style={{
          fontSize: "1.25rem",
          fontWeight: "700",
          textAlign: "center",
          marginBottom: "1rem",
        }}
      >
        {monthNames[currentMonth]} {currentYear}
      </div>

      {/* Streak Count */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "1.5rem",
          padding: "1rem",
          background: "rgba(255,255,255,0.15)",
          borderRadius: "12px",
        }}
      >
        <div style={{ fontSize: "3rem", marginBottom: "0.5rem" }}>🔥</div>
        <div style={{ fontSize: "2rem", fontWeight: "700" }}>{streak} Days</div>
        <div style={{ fontSize: "0.875rem", opacity: 0.9 }}>Current Streak</div>
      </div>

      {/* Weekday Headers */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          gap: "0.5rem",
          marginBottom: "0.5rem",
        }}
      >
        {["S", "M", "T", "W", "T", "F", "S"].map((day, i) => (
          <div
            key={i}
            style={{
              textAlign: "center",
              fontSize: "0.75rem",
              fontWeight: "700",
              opacity: 0.7,
            }}
          >
            {day}
          </div>
        ))}
      </div>

      {/* Calendar Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          gap: "0.5rem",
        }}
      >
        {/* Empty cells before month starts */}
        {Array.from({ length: startingDayOfWeek }).map((_, i) => (
          <div key={`empty-${i}`} />
        ))}

        {/* Calendar days */}
        {Array.from({ length: daysInMonth }).map((_, i) => {
          const day = i + 1;
          const hasStreak = streakDays.has(day);
          const isToday = day === today.getDate();

          return (
            <div
              key={day}
              style={{
                aspectRatio: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
                fontSize: "0.875rem",
                fontWeight: "600",
                background: hasStreak
                  ? "rgba(255,255,255,0.3)"
                  : "rgba(255,255,255,0.1)",
                border: isToday ? "2px solid #fff" : "none",
                position: "relative",
              }}
            >
              {day}
              {hasStreak && (
                <div
                  style={{
                    position: "absolute",
                    top: "2px",
                    right: "2px",
                    fontSize: "0.625rem",
                  }}
                >
                  🔥
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div
        style={{
          marginTop: "1rem",
          display: "flex",
          gap: "1rem",
          justifyContent: "center",
          fontSize: "0.75rem",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
          <div
            style={{
              width: "16px",
              height: "16px",
              borderRadius: "4px",
              background: "rgba(255,255,255,0.3)",
            }}
          />
          Active
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
          <div
            style={{
              width: "16px",
              height: "16px",
              borderRadius: "4px",
              background: "rgba(255,255,255,0.1)",
            }}
          />
          Inactive
        </div>
      </div>
    </div>
  );
};

export default StreakCalendar;
